import type { ElementType, ReactNode } from "react";
import clsx from "clsx";

type EyebrowProps = {
  children: ReactNode;
  /** Render without the trailing gold rule. */
  plain?: boolean;
  as?: ElementType;
  className?: string;
};

/** Gold eyebrow label: the only uppercase element in the system. */
const Eyebrow = ({ children, plain = false, as: Tag = "div", className }: EyebrowProps) => (
  <Tag className={clsx("pz-eyebrow", plain && "pz-eyebrow--plain", className)}>{children}</Tag>
);

export default Eyebrow;
